import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface WoRow {
  id: number
  numero_scheda?: string
  customer_nome?: string
  vehicle_targa?: string
  vehicle_marca?: string
  vehicle_modello?: string
  stato?: string
  data_fine_prevista?: string
}

const columns = [
  {
    title: 'OdL',
    dataIndex: 'numero_scheda',
    key: 'numero_scheda',
    width: 130,
    render: (v: string, r: WoRow) => (
      <Space size={4}>
        <span style={{ fontWeight: 600, color: '#1677ff' }}>{v ?? '—'}</span>
        {r.customer_nome && <span style={{ color: '#888', fontSize: 12 }}>· {r.customer_nome}</span>}
      </Space>
    ),
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: unknown, r: WoRow) => (
      <Space size={4}>
        {r.vehicle_targa && <Tag color="geekblue" style={{ fontWeight: 600 }}>{r.vehicle_targa}</Tag>}
        <span>{[r.vehicle_marca, r.vehicle_modello].filter(Boolean).join(' ')}</span>
      </Space>
    ),
  },
  {
    title: 'Scadenza',
    dataIndex: 'data_fine_prevista',
    key: 'data_fine_prevista',
    width: 110,
    render: (v: string) => v ? <Tag color="red">{new Date(v).toLocaleDateString('it-IT')}</Tag> : '—',
  },
]

export function TableWoInRitardoWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<WoRow[]>({
    queryKey: ['dashboard', 'wo-in-ritardo-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/work-orders/', { params: { scadute: true, limit: 20 } })
      return res.data?.items ?? []
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="OdL in ritardo">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessun OdL in ritardo' }}
        onRow={(r) => ({ onClick: () => navigate(`/schede-lavoro/${r.id}`), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
